function initSplide(selector, options) {
    const sliders = document.querySelectorAll(selector);

    sliders.forEach(slider => {
        new Splide(slider, options).mount();
    });
}

function splider() {

    initSplide('.slide-for-blog', {
        type: 'loop',
        perPage: 3,
        perMove: 1,
        gap: 16,
        pagination: false,
        arrows: true,
        autoplay: true,
        breakpoints: {
            767: { 
                perPage: 2 
            },
            500: { 
                perPage: 1 
            }
        }
    });

    initSplide('.slider-with-text', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: true,
        autoplay: true,
    });

    initSplide('.single-slider', {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        pagination: false,
        arrows: true,
        autoplay: true,
    });

}

document.addEventListener('DOMContentLoaded', splider);




// function splider() {
//     const sliders = document.querySelectorAll('.single-slider');

//     sliders.forEach((slider) => {
//         new Splide(slider, {
//             type: 'loop',
//             perPage: 1,
//             perMove: 1,
//             pagination: false,
//             arrows: true,
//             autoplay: true,
//         }).mount();
//     });
// }

// document.addEventListener('DOMContentLoaded', splider);

